import React, { useState } from "react";
import { useLanguage } from "./Context/LanguageContext";
import translations from "./translations";
import "../styles/JoinUs.css";

function JoinUs() {
  const { language } = useLanguage();
  const t = translations[language];
  
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [resume, setResume] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  // Replace this with your actual Google Form ID
  const GOOGLE_FORM_ID = "13BDhT1ir8E_GiOxoCU30cfP2sTMlp241_9gVBaQGZf0";
  const GOOGLE_FORM_URL = `https://docs.google.com/forms/d/13BDhT1ir8E_GiOxoCU30cfP2sTMlp241_9gVBaQGZf0/`;
  
  // Replace these with your actual Google Form field IDs
  const NAME_FIELD_ID = "entry.123456789";
  const EMAIL_FIELD_ID = "entry.987654321";
  const PHONE_FIELD_ID = "entry.456789123";
  const MESSAGE_FIELD_ID = "entry.789123456";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(false);

    try {
      // Create a FormData object to send
      const formData = new FormData();
      formData.append(NAME_FIELD_ID, name);
      formData.append(EMAIL_FIELD_ID, email);
      formData.append(PHONE_FIELD_ID, phone);
      formData.append(MESSAGE_FIELD_ID, message);
      
      // Note: Google Forms doesn't easily support file uploads from external forms
      // Typically, you would need to:
      // 1. Upload the file to a storage service (e.g., Firebase, AWS S3)
      // 2. Include the link to the file in your Google Form submission
      // For demonstration purposes, we'll skip the file handling
      
      // Using fetch to submit the form data
      // This might face CORS issues, which is a limitation when submitting to Google Forms externally
      const response = await fetch(GOOGLE_FORM_URL, {
        method: "POST",
        mode: "no-cors", // This means we won't be able to process the response
        body: formData,
      });
      
      // Since we're using no-cors, we can't actually check the response
      // So we'll just assume it was successful if there was no exception
      setSuccess(true);
      
      // Reset the form
      setName("");
      setEmail("");
      setPhone("");
      setResume(null);
      setMessage("");
      
    } catch (err) {
      console.error("Error submitting form:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  // Alternative approach: open the Google Form in a new tab with prefilled values
  const openGoogleForm = () => {
    const baseUrl = `https://docs.google.com/forms/d/e/${GOOGLE_FORM_ID}/viewform?usp=pp_url`;
    const params = new URLSearchParams();
    params.append(NAME_FIELD_ID.replace("entry.", "entry."), name);
    params.append(EMAIL_FIELD_ID.replace("entry.", "entry."), email);
    params.append(PHONE_FIELD_ID.replace("entry.", "entry."), phone);
    params.append(MESSAGE_FIELD_ID.replace("entry.", "entry."), message);
    
    window.open(`${baseUrl}&${params.toString()}`, "_blank");
  };

  return (
    <section className="join-us-section">
      <div className="container">
        <div className="join-us-content">
          <div className="join-us-header">
            <h2>{t.joinUsTitle}</h2>
            <p>{t.joinUsSubtitle}</p>
          </div>
          
          <form onSubmit={handleSubmit} className="join-us-form">
            <div className="form-group">
              <label htmlFor="name">{t.fullName} *</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                placeholder={t.enterName}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">{t.emailAddress} *</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder={t.enterEmail}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="phone">{t.phoneNumber}</label>
              <input
                type="tel"
                id="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder={t.enterPhone}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="resume">{t.resumeCV} *</label>
              <input
                type="file"
                id="resume"
                onChange={(e) => setResume(e.target.files[0])}
                required
                accept=".pdf,.doc,.docx"
              />
              <small>{t.resumeInstruction}</small>
            </div>
            
            <div className="form-group">
              <label htmlFor="message">{t.additionalInfo}</label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder={t.additionalInfoPlaceholder}
                rows="4"
              ></textarea>
            </div>
            
            <div className="form-actions">
              <button 
                type="submit" 
                className="submit-btn"
                disabled={loading}
              >
                {loading ? t.submitting : t.submitApplication}
              </button>
              <button 
                type="button" 
                className="google-form-btn"
                onClick={openGoogleForm}
              >
                {t.openInGoogleForm}
              </button>
            </div>
            
            {success && (
              <div className="success-message">
                {t.successMessage}
              </div>
            )}
            
            {error && (
              <div className="error-message">
                {t.errorMessage}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default JoinUs; 